import { ASSIGN_COUPON, ASSIGN_COUPON_SUCCESS, ASSIGN_COUPON_ERROR, GET_EMPTY_ASSIGN_COUPON } from './../../actionType.js';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const AssignCoupon = (state = initialState, action) => {
  switch (action.type) {
    case ASSIGN_COUPON:
      state = {
        ...state,
        data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case ASSIGN_COUPON_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case ASSIGN_COUPON_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case GET_EMPTY_ASSIGN_COUPON:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default AssignCoupon;
